"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.languagesList = void 0;
const languagesList = exports.languagesList = [{
  'name': 'English',
  'code': 'en',
  'source': true,
  'value': 'en',
  'label': 'English'
}, {
  'name': 'Français',
  'code': 'fr',
  'value': 'fr',
  'label': 'Français'
}, {
  'name': 'Deutsch',
  'code': 'de',
  'value': 'de',
  'label': 'Deutsch'
}, {
  'name': 'Italiano',
  'code': 'it',
  'value': 'it',
  'label': 'Italiano'
}];